import { Timestamp } from "firebase/firestore"

export const formatLicenseNumber = (licenseNumber) => {
	try {
		if (licenseNumber.length === 7) {
			return licenseNumber.substring(0, 2) + "-" + licenseNumber.substring(2, 5) + "-" + licenseNumber.substring(5, 7)
		} else if (licenseNumber.length === 8) {
			return licenseNumber.substring(0, 3) + "-" + licenseNumber.substring(3, 5) + "-" + licenseNumber.substring(5, 8)
		} else {
			return null
		}
	} catch (e) {
		return null
	}
}

export const firebaseTimeStampToDate = (timeStamp) => {
	try {
		const fireBaseTime = new Date(timeStamp._seconds * 1000 + timeStamp._nanoseconds / 1000000)
		return fireBaseTime
	} catch (e) {
		return null
	}
}

export const dateToFirebaseTimestamp = (date) => {
	const timestamp = Timestamp.fromDate(date)
	const timestampJson = { _seconds: timestamp.seconds, _nanoseconds: timestamp.nanoseconds }
	//return timestamp ? timestampJson : null
	return timestampJson
}

export const statuses = {
	PENDINGREVIEW: "ממתין לאישור מנהלן",
	PENDINGUPDATE: "ממתין לעידכון",
	PENDINGAPPROVED: "מאושר",
	ACTIVE: "פעיל",
	DRAFT: "טיוטה",
	CLOSEDDEAL: "סגור - עסקה",
	CLOSEDNODEAL: "סגור - ללא עסקה",
	CANCELLED: "מבוטל",
	CLOSEDERROR: "סגור - תקלה"
}
